export const winPercentageAsNum = percentage =>
  Number(percentage.replace(".", ""));
